import React from 'react';
import { injectIntl } from 'react-intl';
import { useMutation } from '@apollo/react-hooks';
import Button from '@uniiverse/library/components/button';
import Config from 'config';
import { addons } from './locale'; 
import style from './index-module.css';
import UPDATE_ADDON_MUTATION from '../update-add-on.gql';

const CUSTOM_TAX_SELECTION_ID = 'new_custom_tax';
const PLACEHOLDER_TAX_RATE_ID = 'placeholder_tax_rate';
const EMPTY_TAX_RATE_ID = 'empty_tax_rate';
const FILTER_TAX_IDS = [CUSTOM_TAX_SELECTION_ID, PLACEHOLDER_TAX_RATE_ID, EMPTY_TAX_RATE_ID];

const filterTaxIds = (taxIds) => taxIds.filter((id) => !FILTER_TAX_IDS.includes(id));

const EditButton = injectIntl((props) => {
  const { intl, shapeNewRates, shapeNewImages } = props;
  const [updateAddOnMutation] = useMutation(UPDATE_ADDON_MUTATION); 

  const handleClick = async () => {
    const { taxes, listingIds, rates,name, images, description, hostPaysCommission,
      currency, addOnId, hostId, renderErrorMessages, validateForm, postPurchaseMessage,
      sanitizeEditorText, prepareAddOnCustomization, prepareAvailabilityRules } = props;
    if (validateForm()) {
      const newTaxes = filterTaxIds(taxes.map((tax) => tax.id));
      const newEventIds = listingIds;
      const newRates = shapeNewRates(rates, name);
      const newImages = shapeNewImages(images);
      const newAddon = {
        name,
        description: sanitizeEditorText(description),
        hostPaysCommission: JSON.parse(hostPaysCommission),
        currency,
        images: newImages,
        rates: newRates,
        postPurchaseMessage: sanitizeEditorText(postPurchaseMessage),
        suppressQrCode: props.hideQRCode
      };

      await updateAddOnMutation({
        variables: {
          id: addOnId,
          taxIds: newTaxes,
          eventIds: newEventIds,
          addon: newAddon,
          hostId,
          addOnCustomization: prepareAddOnCustomization(),
          availabilityRules: prepareAvailabilityRules()
        }}).then(({ data }) => {
        const { errors } = data.updateAddOn;

        if (errors && errors.length > 0) {
          renderErrorMessages(errors);
        }
        else {
          window.location.href = `${Config.api.host}/dashboard/add-ons`;
        }
      });
    }
  }

  return (
    <div>
      <Button
        className={style.createAddOnButton}
        type='primary'
        onClick={handleClick}
      >
        {intl.formatMessage(addons.saveAddon)}
      </Button>
      {props.renderCancel && props.renderCancel()}
    </div>
  );
});

export default EditButton;
